import React from 'react';

import { BlockEventSingleTitle } from '@components/block-event-single/components/BlockEventSingleRuleBuilder/styled';
import { IBlockEventSingleRuleBuilder } from '@components/block-event-single/components/BlockEventSingleRuleBuilder/typed';
import BlockEventSingleRuleGroup from '@components/block-event-single/components/BlockEventSingleRuleGroup';

const BlockEventSingleRuleBuilder: React.FC<IBlockEventSingleRuleBuilder> = ({
  mode,
  data,
  blockType,
  onChange,
  onBlockRulesChange,
  onBlockTypeChange,
}) => {
  return (
    <div style={{ width: '100%' }}>
      <BlockEventSingleTitle>
        <span>Set Block Rules</span>
      </BlockEventSingleTitle>
      {data?.map((blockEventSingleData, orIndex) => {
        return (
          <BlockEventSingleRuleGroup
            mode={mode}
            key={`BlockEventSingleRuleGroup_${orIndex}`}
            index={orIndex}
            data={blockEventSingleData}
            blockType={blockType}
            onChange={(...rest) => onChange?.(orIndex, ...rest)}
            onBlockRulesChange={onBlockRulesChange}
            onBlockTypeChange={(value) => onBlockTypeChange?.(value, orIndex)}
          />
        );
      })}
    </div>
  );
};

export default BlockEventSingleRuleBuilder;
